import { jsx as e, jsxs as m } from "react/jsx-runtime";
import * as l from "@radix-ui/react-checkbox";
import { Minus as k, Check as I } from "lucide-react";
import { forwardRef as w, useId as v } from "react";
import { c as h } from "./cn-DlLpp5ix.js";
const y = {
  sm: "h-4 w-4",
  md: "h-5 w-5"
}, a = {
  sm: 12,
  md: 14
}, R = w(
  function({ size: t = "md", label: o, description: r, className: f, id: u, disabled: c, checked: i, ...x }, b) {
    const p = v(), n = u ?? `checkbox-${p}`, s = r ? `${n}-description` : void 0, g = i === "indeterminate", d = /* @__PURE__ */ e(
      l.Root,
      {
        ref: b,
        id: n,
        disabled: c,
        checked: i,
        "aria-describedby": s,
        className: h(
          "inline-flex shrink-0 items-center justify-center rounded-sm border transition-colors",
          "focus-visible:outline-none focus-visible:shadow-ring-focus",
          y[t],
          // Idle / hover.
          "border-strong bg-bg-base hover:border-accent",
          // Checked + indeterminate share the accent fill.
          "data-[state=checked]:border-accent data-[state=checked]:bg-accent data-[state=checked]:text-on-accent",
          "data-[state=indeterminate]:border-accent data-[state=indeterminate]:bg-accent data-[state=indeterminate]:text-on-accent",
          // Disabled.
          "disabled:cursor-not-allowed disabled:opacity-60",
          f
        ),
        ...x,
        children: /* @__PURE__ */ e(l.Indicator, { className: "flex items-center justify-center", children: g ? /* @__PURE__ */ e(
          k,
          {
            "aria-hidden": "true",
            width: a[t],
            height: a[t],
            strokeWidth: 2.5
          }
        ) : /* @__PURE__ */ e(
          I,
          {
            "aria-hidden": "true",
            width: a[t],
            height: a[t],
            strokeWidth: 2.5
          }
        ) })
      }
    );
    return !o && !r ? d : /* @__PURE__ */ m("div", { className: "flex items-start gap-2", children: [
      d,
      /* @__PURE__ */ m("div", { className: "flex flex-col gap-0.5", children: [
        o ? /* @__PURE__ */ e(
          "label",
          {
            htmlFor: n,
            className: h(
              "cursor-pointer text-sm font-medium text-primary",
              c && "cursor-not-allowed opacity-60"
            ),
            children: o
          }
        ) : null,
        r ? /* @__PURE__ */ e("p", { id: s, className: "text-xs text-secondary", children: r }) : null
      ] })
    ] });
  }
);
export {
  R as C
};
//# sourceMappingURL=Checkbox-wOzf8suy.js.map
